"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldLogThankYouMessage = void 0;
function shouldLogThankYouMessage() {
    try {
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
            return true;
        }
        return false;
    }
    catch (ex) {
        return false;
    }
}
exports.shouldLogThankYouMessage = shouldLogThankYouMessage;
